<template>
  <div id="wrapper" class="page" v-if="project_report">
    <div id="content-wrapper" style="height: 100%;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" @click.prevent>
            <span>Báo cáo dự án</span>
          </a>
        </li>
      </ol>
      <div class="container-fluid">
        <div class="form-inline">
          <button class="btn btn-info mb-2" @click.prevent="openModal">
            <i class="far fa-file-alt"></i> Chọn báo cáo
          </button>
          <div style="flex-grow: 1" class="text-center"></div>
          <button
            v-if="report != null"
            class="btn btn-success"
            @click.prevent="excelReport"
          >
            <i class="far fa-file-excel"></i>
            Export to Excel
            <!-- Xuất excel -->
          </button>
        </div>
        <!-- View IndexReportX -->
        <!-- Mẫu 01 - Danh sách khách hàng -->
        <report1 v-if="report == 1" :customer="customer"></report1>

        <!-- Mẫu 02 - Báo cáo hợp đồng dự án -->
        <report2 v-if="report == 2"></report2>

        <!-- Mẫu 03 - Báo cáo bonus theo nhân viên -->
        <report3 v-if="report == 3"></report3>

        <!-- Mẫu 04 - Báo cáo bonus theo dự án -->
        <report4 v-if="report == 4"></report4>

        <!-- Mẫu 05 - Báo cáo bonus tổng hợp-->
        <report5 v-if="report == 5"></report5>
      </div>

      <!-- Hien thi LOAI BAO CAO -->
      <b-modal
        v-model="modalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        title="MẪU BÁO CÁO"
        text-center
      >
        <b-form autocomplete="false">
          <!-- 1. Ten loai bao cao -->
          <b-row>
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Loại báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select v-model="reportKind" @change="changeReportKind">
                  <b-form-select-option value="1"
                    v-if="project_report1 || project_report_all"
                    >Mẫu 01 - Danh sách khách hàng
                  </b-form-select-option>

                  <b-form-select-option value="2"
                    v-if="project_report2 || project_report_all"
                    >Mẫu 02 - Báo cáo hợp đồng dự án
                  </b-form-select-option>

                  <!-- Chuyển sang nút report trong bonus -->
                  <!-- <b-form-select-option value="3"
                    v-if="project_report3 || project_report_all"
                    >Mẫu 03 - Báo cáo Bonus theo nhân viên
                  </b-form-select-option>

                  <b-form-select-option value="4"
                    v-if="project_report4 || project_report_all"
                    >Mẫu 04 - Báo cáo Bonus theo dự án
                  </b-form-select-option>

                   <b-form-select-option value="5"
                    v-if="project_report5 || project_report_all"
                    >Mẫu 05 - Báo cáo Bonus tổng hợp
                  </b-form-select-option> -->
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- 2. Ten option bao cao -->
          <!-- Report 1 -->
          <b-row v-if="reportKind == 1">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b> Tên khách hàng </b>
                  <span class="text-danger">*</span>
                </template>
                <!-- <multiselect
                  v-model="customer"
                  placeholder
                  track-by="id"
                  label="ten"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :options="customers"
                  :taggable="true"
                  :multiple="false"
                ></multiselect> -->

                <b-form-select
                  v-model="customer"
                  :options="customers"
                  value-field="id"
                  text-field="ten"
                >
                  <template #first>
                    <b-form-select-option :value="null"
                      >Tất cả
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

           <!-- Report 3 : BAO CAO BONUS THEO NHAN VIEN-->
          <b-row v-if="reportKind == 3">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  <b>Kỳ báo cáo</b>
                  <span class="text-danger"> *</span>
                </template>
                <b-form-select
                  v-model="kyBaoCao_Report3"
                  :options="optionsKyBaoCao_Report3"
                  @change="changeKyBaoCao_Report3"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 3">
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Từ ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="fromDateReport3"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
                <!-- <my-date-picker v-model="toDate" :required="true"></my-date-picker> -->
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <template v-slot:label>
                  <b>Đến ngày</b>
                  <span class="text-danger"> *</span>
                </template>
                <vue-datepicker-local
                  style="width: 100%"
                  v-model="toDateReport3"
                  :local="local"
                  clearable
                  format="DD/MM/YYYY"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="reportKind == 3">
            <b-col>
              <b-form-group>
                <template v-slot:label>
                  Nhân viên
                  <!-- <span class="text-danger">*</span> -->
                </template>
                <multiselect
                  v-model="employeeid_selected"
                  placeholder
                  track-by="id"
                  label="mahovaten"
                  selectedLabel="Đang chọn"
                  select-label="Enter để chọn"
                  deselectLabel="Enter để xóa"
                  :searchable="true"
                  :options="employees"
                  :value ="employeeid_selected">
                </multiselect>
              </b-form-group>
            </b-col>
          </b-row>



          <!-- 3. Button Select -->
          <b-row>
            <b-col>
              <b-form-group>
                <b-button
                  class="mr-2"
                  variant="info"
                  @click.prevent="selectReport"
                >
                  <i class="fas fa-check mr-2"></i>Chọn
                </b-button>
                <b-button
                  class="mr-2"
                  variant="secondary"
                  @click.prevent="closeModal"
                >
                  <i class="fas fa-times mr-2"></i>Đóng
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Report1 from "../components/Project/Report/Report1";
import Report2 from "../components/Project/Report/Report2";
import Report3 from "../components/Project/Report/Report3";
import Report4 from "../components/Project/Report/Report4";
import Report5 from "../components/Project/Report/Report5";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";

export default {
  name: "ContractsReport",
  components: {
    Report1,
    Report2,
    Report3,
    Report4,
    Report5,
    Multiselect,
    VueDatepickerLocal,
  },
  data() {
    return {
      optionsReport: [],
      modalShow: false,
      report: null,
      reportKind: null,
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      //Report 1
      customers: [],
      customer: null,

      //Report 3: Bao cao bonus theo NV
      fromDateReport3: new Date(new Date().getFullYear(), 0, 1),
      toDateReport3: new Date(new Date().getFullYear(), 0, 31),
      optionsKyBaoCao_Report3: [
        { value: 0, text: "Tháng 1" },
        { value: 1, text: "Tháng 2" },
        { value: 2, text: "Tháng 3" },
        { value: 3, text: "Tháng 4" },
        { value: 4, text: "Tháng 5" },
        { value: 5, text: "Tháng 6" },
        { value: 6, text: "Tháng 7" },
        { value: 7, text: "Tháng 8" },
        { value: 8, text: "Tháng 9" },
        { value: 9, text: "Tháng 10" },
        { value: 10, text: "Tháng 11" },
        { value: 11, text: "Tháng 12" },
        { value: 12, text: "Quý I" },
        { value: 13, text: "Quý II" },
        { value: 14, text: "Quý III" },
        { value: 15, text: "Quý IV" },
      ],
      kyBaoCao_Report3: 0,

      employeeid_selected: 0,
      employees: [],
      vitricongviecs: [],
      loaihopdongs: [],
      departments: [],
      //  [{ name: "Tất cả", value: null }],

    };
  },
  // mounted() {
  //   this.employeeid_selected = this.employees.find(option => this.employees.id === 0);
  // },
  computed: {
    //Permission
    project_report() {
      return this.$store.getters.hasPermission("project_report");
    },
    project_report_all() {
      return this.$store.getters.hasPermission("project_report_all");
    },
    project_report1() {
      return this.$store.getters.hasPermission("project_report1");
    },
    project_report2() {
      return this.$store.getters.hasPermission("project_report2");
    },
    // project_report3() {
    //   return this.$store.getters.hasPermission("project_report3");
    // },
    // project_report4() {
    //   return this.$store.getters.hasPermission("project_report4");
    // },
    // project_report5() {
    //   return this.$store.getters.hasPermission("project_report5");
    // },
  },
  methods: {
    beforeRouteEnter(to, from, next) {
      axios
        .all([
          axios.get(`/api/picklist?q=vitricongviec|loaihopdong|tinhtranghoso`),
          axios.get(`/api/department`),
          // axios.get(`/api/employee`, { params: to.query }),
        ])
        .then(
          axios.spread((picklists, departments) => {
            next((vm) => vm.initData(picklists.data, departments.data));
          })
        );
    },
   initData(picklists, departments) {
      this.vitricongviecs = picklists.filter(
        (x) => x.pickListType == "vitricongviec"
      );
      this.loaihopdongs = picklists.filter(
        (x) => x.pickListType == "loaihopdong"
      );
      this.departments = departments;
    },
    openModal() {
      this.modalShow = true;
      this.report = null;
    },
    closeModal(){
       this.modalShow = false;
       //Report 1: danh sach khach hang
       this.customer = null;
    },
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.report = this.report;
      //Report 1 - Tham so cho excel

      if (this.report == 1) query.customer = this.customer;
      else if (this.report == 3) query.empid = this.employeeid_selected;
      axios({
        method: "get",
        url: `/api/CustomerContractReport/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {});
    },
    selectReport() {
      // if (this.reportKind == 1 && this.customer == null) {
      //   this.$toast.error("Vui lòng chọn khách hàng", "Lỗi", { timeout: 2000 });
      //   return;
      // }
      this.$toast.error("Ma " + this.employeeid_selected.id, "Lỗi", { timeout: 3000 });
      this.report = this.reportKind;
      this.modalShow = false;
		},

    changeReportKind() {
      if (this.reportKind == 1 && this.customers.length <= 0) {
        axios
          .get(`/api/customer`)
          .then((response) => {
            this.customers = response.data;
          })
          .catch((err) => {});
      }
      if (this.reportKind == 3 && this.employees.length <= 0) {
        axios
          .get("/api/employee/getall")
          .then((response) => {
            this.employees = response.data;
            this.employees.unshift({mahovaten: "Tất cả", id: 0 });
          })
          .catch((err) => {});
      }


    },

    changeKyBaoCao_Report3() {
      //0.Thang 1
      if (this.kyBaoCao_Report3 == 0) {
         this.fromDateReport3 = new Date(new Date().getFullYear(), 0, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 0, 31);
      }
      //1.Thang 2
      else if (this.kyBaoCao_Report3 == 1) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 1, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 2, 0);
      }
      //2.Thang 3
      else if (this.kyBaoCao_Report3 == 2) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 2, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 2, 31);
      }
      //3.Thang 4
      else if (this.kyBaoCao_Report3 == 3) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 3, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 3, 30);
      }
      //4.Thang 5
      else if (this.kyBaoCao_Report3 == 4) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 4, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 4, 31);
      }
      //5.Thang 6
      else if (this.kyBaoCao_Report3 == 5) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 5, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 5, 30);
      }
      //6.Thang 7
      else if (this.kyBaoCao_Report3 == 6) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 6, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 6, 31);
      }
      //7.Thang 8
      else if (this.kyBaoCao_Report3 == 7) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 7, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 7, 31);
      }
      //8.Thang 9
      else if (this.kyBaoCao_Report3 == 8) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 8, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 8, 30);
      }
      //9.Thang 10
      else if (this.kyBaoCao_Report3 == 9) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 9, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 9, 31);
      }
      //10.Thang 11
      else if (this.kyBaoCao_Report3 == 10) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 10, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 10, 30);
      }
      //11.Thang 12
      else if (this.kyBaoCao_Report3 == 11) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 11, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 11, 31);
      }
      //12.Quy I
      else if (this.kyBaoCao_Report3 == 12) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 0, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 2, 31);
      }
      //13.Quy II
      else if (this.kyBaoCao_Report3 == 13) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 3, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 5, 30);
      }
      //14.Quy III
      else if (this.kyBaoCao_Report3 == 14) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 6, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 8, 30);
      }
      //15.Quy IV
      else if (this.kyBaoCao_Report3 == 15) {
        this.fromDateReport3 = new Date(new Date().getFullYear(), 9, 1);
        this.toDateReport3 = new Date(new Date().getFullYear(), 11, 31);
      }

    },


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
